module.exports = __webpack_public_path__ + "img/edge_activites_canoe.f6f52e03.svg";